import { CLIENT_ID, REDIRECT_URI, SPOTIFY_ACCOUNT_API_BASE_URL as BASE_URL, APP_SCOPE } from "../utils/constants/connectionConstants";
import { base64encode, generateRandomString, sha256 } from "../utils/encodingUtils"
import { clearAccessToken, clearRefreshToken, loadAccessToken, loadCodeVerifier, loadExpireTime, loadRefreshToken, saveAccessToken, saveCodeVerifier, saveExpireTime, saveRefreshToken } from "../utils/localStorageUtils";

const DEBUG = false;

export const getUserAuthUrl = async (scope = APP_SCOPE) => {
    const endpoint = "/authorize";
    const authUrl = new URL(`${BASE_URL}${endpoint}`);

    const codeVerifier = generateRandomString(64);
    const hashed = await sha256(codeVerifier);
    const codeChallenge = base64encode(hashed);

    saveCodeVerifier(codeVerifier);

    const params = {
        response_type: 'code',
        client_id: CLIENT_ID,
        scope,
        code_challenge_method: 'S256',
        code_challenge: codeChallenge,
        redirect_uri: REDIRECT_URI
    }

    authUrl.search = new URLSearchParams(params).toString();
    return authUrl;
}

export const getBaseAccessToken = code => {
    const codeVerifier = loadCodeVerifier();

    const params = {
        client_id: CLIENT_ID,
        grant_type: 'authorization_code',
        code,
        redirect_uri: REDIRECT_URI,
        code_verifier: codeVerifier 
    };

    return getAccessToken(params);
}

export const checkRefreshToken = async () => {
    const currentTime = new Date().getTime();
    
    const expireTime = loadExpireTime();

    if(currentTime > expireTime)
    {
        const response = await getRefreshToken();

        if(response.access_token)
        {
            saveTokensAndTime(response);
        }
        else
        {
            // handle error
        }
    }
}

const getRefreshToken = () => {
    const refreshToken = loadRefreshToken();

    const params = {
        grant_type: 'refresh_token',
        refresh_token: refreshToken,
        client_id: CLIENT_ID
    };

    return getAccessToken(params);
}

const getAccessToken = (params) => {
    const endpoint = "/api/token";
    const url = `${BASE_URL}${endpoint}`

    const payload = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams(params)
    };

    return new Promise((resolve, reject) => {
        fetch(url, payload)
            .then((response) => {
                if(DEBUG) console.log(response);
                return response.json();
            })
            .then((data) => {
                if(DEBUG) console.log(data);
                return resolve(data);
            })
            .catch((error) => reject(error))
    });
}

// #region Interaction with local storage

const CLEAR_TOKENS = false;

export const loadTokens = () => {
    if(CLEAR_TOKENS)
    {
        clearAccessToken();
        clearRefreshToken();
    }

    const accessToken = loadAccessToken();
    const refreshToken = loadRefreshToken();

    return { accessToken, refreshToken }
}

export const saveTokensAndTime = (response) => {
    saveAccessToken(response.access_token);
    
    if(response.refresh_token) {
        saveRefreshToken(response.refresh_token);
    }

    if(response.expires_in) {
        const expireTime = new Date().getTime() + response.expires_in * 900;
        saveExpireTime(expireTime);
    }
}

// #endregion Interaction with local storage